import http from "../http-common";
import authHeader from '../auth-header';

export default class ConfiguracionService {

    buscarConfiguracion(){
        return http.get("jaapzproceso/configuracion/buscarConfiguracion", { headers: authHeader() });
    }
    
    guardarConfiguracion(configuracion){
        return http.post("jaapzproceso/configuracion/guardar" , configuracion, { headers: authHeader() });
    }
}